import React from "react";
import GlobalStyle from "./globalStyles";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'

import Navbar from "./components/Navbar/Navbar";

//pages
import Home from "./pages/Home";
import Kontakt from "./pages/Kontakt";
import Chronik from "./pages/Chronik";
import Gallerie from "./pages/Gallerie";
import Hörprobe from "./pages/Hörprobe";
import Termine from "./pages/Termine";
import Footer from "./components/Footer/Footer";
import Impressum from "./pages/Impressum";

function App() {
  return (
    <Router>
      <GlobalStyle />
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home/>}/>
        <Route path="/chronik" exact element={<Chronik/>}/>
        <Route path="/galerie" exact element={<Gallerie/>}/>
        <Route path="/hoerprobe" exact element={<Hörprobe/>}/>
        <Route path="/kontakt" exact element={<Kontakt/>}/>
        <Route path="/termine" exact element={<Termine/>}/>
        <Route path="/impressum" exact element={<Impressum/>}/>
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
